import Vue from "vue";

const state = {
  countryList: [],
  stateList: [],
  listTaxIdInfo: [],
  listPaidFreeKbn: [],
  listCoolKbn: [],
  listOriginCountry: [],
  listUnit: [],
  currencyCd: {},
  shipmentTerm: {},
  weightUnidCd: {},
  listDestinationState: [],
  listVatRegisterDiv: [],
  listVatRegisterNotice: [],
  listVatRegisterHint: []
};

const mutations = {
  setInitData(state, data) {
    if (data.takkyubinCountryResponse) {
      state.countryList =
        data.takkyubinCountryResponse.takkyubinCountryList || [];
    }
    if (data.upsCountryResponse) {
      state.stateList = data.upsCountryResponse.countryList || [];
    }
    if (data.taxIdInfoResponse) {
      state.listTaxIdInfo = data.taxIdInfoResponse.taxIdInfoList || [];
    }
    state.listPaidFreeKbn = getItemInfo("paidFreeKbn", data);
    state.listCoolKbn = getItemInfo("coolKbn", data);

    const currencyCd = getItemInfo("currencyCd", data);
    state.currencyCd = currencyCd && currencyCd[0];

    const shipmentTerm = getItemInfo("shipmentTerm", data);
    state.shipmentTerm = shipmentTerm && shipmentTerm[0];

    const weightUnidCd = getItemInfo("weightUnidCd", data);
    state.weightUnidCd = weightUnidCd && weightUnidCd[0];

    if (data.originCountryResponse) {
      state.listOriginCountry =
        data.originCountryResponse.originCountryList || [];
    }
    if (data.unitResponse) {
      state.listUnit = data.unitResponse.unitList || [];
    }
    state.listVatRegisterDiv = getItemInfo("vatRegisterDiv", data);
    state.listVatRegisterNotice = getItemInfo("vatRegisterDivNotice", data);
    state.listVatRegisterHint = getItemInfo("vatRegisterDivHint", data);
  },
  setDestinationStateByCountry(state, data) {
    const countries = data.countryList && data.countryList[0];
    const states = countries && countries.stateList;
    const cities = states && states[0].cityList;
    if (cities) {
      state.listDestinationState = cities.map(item => {
        return {
          // id: index + 1,
          name: item.cityName
        };
      });
    }
  }
};

const getters = {
  listCountry: state => state.countryList,
  listState: state => state.stateList,
  listTaxIdInfo: state => state.listTaxIdInfo,
  listPaidFreeKbn: state => state.listPaidFreeKbn,
  listCoolKbn: state => state.listCoolKbn,
  listOriginCountry: state => state.listOriginCountry,
  listUnit: state => state.listUnit,
  currencyCd: state => state.currencyCd,
  shipmentTerm: state => state.shipmentTerm,
  weightUnidCd: state => state.weightUnidCd,
  listDestinationState: state => state.listDestinationState,
  listVatRegisterDiv: state => state.listVatRegisterDiv,
  listVatRegisterNotice: state => state.listVatRegisterNotice,
  listVatRegisterHint: state => state.listVatRegisterHint
};

const actions = {
  // ユーザ情報を取得
  async init({ commit }, params) {
    const { callBack, errorCallBack } = params;
    await Vue.axios
      .get("/kyg060001/init")
      .then(response => {
        const data = response.data;
        if (data) {
          commit("setInitData", data);
          handleError(data, errorCallBack);
          callBack && callBack(response);
        }
      })
      .catch(err => {
        errorCallBack && errorCallBack(err);
      });
  },
  getDestinationStates({ commit }, params) {
    return new Promise(res => {
      const postBody = {
        countryCd: params.countryCd,
        stateCd: params.stateCd
      };
      Vue.axios
        .post("/kyg021001/destination-state", postBody, {})
        .then(response => {
          const data = response && response.data;
          if (data) {
            commit("setDestinationStateByCountry", data);
            res();
          }
        });
    });
  }
};

function getItemInfo(key, data) {
  if (!data.generalItemResponse || !data.generalItemResponse.queriedItemsInfo) {
    return [];
  }
  const queriedItemsInfo = data.generalItemResponse.queriedItemsInfo;
  const sbtIDList = queriedItemsInfo.find(
    item => item.sbtID === key && item.sbtIDList
  );
  return sbtIDList ? sbtIDList.sbtIDList : [];
}

function handleError(data, errorCallBack) {
  const listPaidFreeKbn = getItemInfo("paidFreeKbn", data);

  if (listPaidFreeKbn.length === 0) {
    errorCallBack && errorCallBack();
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
